( function( $, document, window ) {
	'use strict';

	$( function() {
		const $carousel = $( '.js-image-card-collection' );

		$carousel.each( function() {
			const swiper = new Swiper( this, {
				direction: 'horizontal',
				slidesPerView: 1.125,
				spaceBetween: 20,
				loop: true,
				grabCursor: true,

				navigation: {
					prevEl: '.js-image-card-collection-prev',
					nextEl: '.js-image-card-collection-next',
				},

				breakpoints: {
					580: {
						slidesPerView: 2.25,
					},
					768: {
						slidesPerView: 2.75,
					},
					1024: {
						slidesPerView: 3.75,
					},
					1600: {
						slidesPerView: 4.75,
					},
				},

				on: {
					beforeInit: function() {
						let numSlides = this.wrapperEl.querySelectorAll( '.js-image-card-item' ).length;
						if ( numSlides <= 5 ) {
							this.params.loop = false;
						}
					}
				}
			} );
		} );
	} );
} )( jQuery, document, window );
